
import { CommandEntry } from "./CommandEntry";
import { InputInteraction } from "./InputInteraction";
import { ModifierKey } from "./ModifierKey";
import { PlatformCommandInteraction, Platforms } from "./PlatformCommandInteraction";

export class CommandList
{
  profile:string;
  parentProfile:string;
  commandEntries:CommandEntry[];

  constructor( name:string, parent:string = null )
  {
    this.profile = name;
    this.parentProfile = parent;
    this.commandEntries = [];
  } 

  addKeyCommand( name:string, condition:string, key:string, ... mods:ModifierKey[] )
  {
    var entry = new CommandEntry();

    entry.name = name;
    entry.condition = condition;

    let interactionEntry = PlatformCommandInteraction.forDesktop();

    interactionEntry.inputs = [];
    
    mods.forEach(
      ( m )=>
      {
        interactionEntry.inputs.push( InputInteraction.Key( m ) );
      }
    );

    interactionEntry.inputs.push( InputInteraction.Key( key ) );

    entry.platformInteractions.push( interactionEntry );

    this.commandEntries.push( entry );

  }
}